<script lang="ts">
    type Realm = 'classical' | 'music' | 'podcasts';

    const PODCASTS_FALLBACK_BACK = 15;
    const PODCASTS_FALLBACK_FORWARD = 30;

    export let realm: Realm;
    export let isMobile: boolean = false;
    export let isLive: boolean = false;
    export let isNowPlaying: boolean = false;

    $: hideShuffle = realm === 'classical' || isMobile;
    $: hideRepeat = realm === 'classical' && isNowPlaying;
</script>

{#if realm === 'podcasts'}
    <div
        class="podcast-playback-controls"
        data-testid="compact-playback-controls"
    >
        <amp-playback-controls-skip
            direction="back"
            fallbackSeconds={PODCASTS_FALLBACK_BACK}
        />
        <amp-playback-controls-play />
        <amp-playback-controls-skip
            direction="forward"
            fallbackSeconds={PODCASTS_FALLBACK_FORWARD}
        />
    </div>
{:else}
    <div
        class="playback-controls"
        class:playback-controls--now-playing={isNowPlaying}
        data-testid="playback-controls"
    >
        <div class="music-controls">
            <div
                class:music-controls--visually-hidden={isLive}
                class:music-controls--hidden={hideShuffle}
                data-testid="playback-controls-shuffle"
            >
                <amp-playback-controls-shuffle />
            </div>
            <div class="music-controls__main">
                <amp-playback-controls-item-skip direction="previous" />
                <amp-playback-controls-play />
                <amp-playback-controls-item-skip direction="next" />
            </div>
            <div
                class:music-controls--visually-hidden={isLive}
                class:music-controls--hidden={isMobile || hideRepeat}
                data-testid="playback-controls-repeat"
            >
                <amp-playback-controls-repeat />
            </div>
        </div>
    </div>
{/if}

<style lang="scss">
    .playback-controls:not(.playback-controls--now-playing) {
        --skip-icon-width: 28px;
        --skip-icon-height: 24px;
        --playback-controls-play-color: var(--systemSecondary);
        --playback-controls-play-color-hover: var(--systemPrimary);
        --skip-control-color-hover: var(--systemPrimary);
        --lcd-meta-badge-placeholder-width: 0;
        color-scheme: light dark; // stylelint-disable-line property-no-unknown
    }

    .music-controls,
    .music-controls__main {
        display: flex;
        align-items: center;
    }

    .music-controls__main {
        direction: ltr;
    }

    .music-controls--visually-hidden {
        visibility: hidden;
    }

    .music-controls--hidden {
        display: none;
    }

    .podcast-playback-controls {
        display: flex;
        align-items: center;
        direction: ltr;

        & > * {
            margin: 0 1px;
        }

        amp-playback-controls-skip {
            --playback-control-icon-width: 18px;
            --playback-control-icon-height: 18px;
        }
    }
</style>
